import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'site-modules/shared/components/link/link';
import { ToggleButtonBase } from 'site-modules/shared/components/inventory/toggle-button-base/toggle-button-base';

export const ToggleButton = ({ tag = undefined, isActive = false, role = undefined, ...restProps }) => {
  let ariaProps;

  if (tag === Link) {
    ariaProps = isActive ? { 'aria-current': 'page' } : {};
  } else if (role === 'tab') {
    ariaProps = { 'aria-selected': isActive };
  } else {
    ariaProps = { 'aria-pressed': isActive };
  }

  return <ToggleButtonBase {...restProps} tag={tag} isActive={isActive} role={role} {...ariaProps} />;
};

ToggleButton.propTypes = {
  tag: PropTypes.elementType,
  isActive: PropTypes.bool,
  role: PropTypes.string,
};
